"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const prop_types_1 = __importDefault(require("prop-types"));
const react_use_1 = require("react-use");
const immutable_1 = require("immutable");
const uuid_1 = require("uuid");
// MUI
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const mui_1 = require("tss-react/mui");
// MUI ICONS
const Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
const CancelPresentation_1 = __importDefault(require("@mui/icons-material/CancelPresentation"));
const Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
const VisibilityOff_1 = __importDefault(require("@mui/icons-material/VisibilityOff"));
const Visibility_1 = __importDefault(require("@mui/icons-material/Visibility"));
const MoreVert_1 = __importDefault(require("@mui/icons-material/MoreVert"));
const Flip_1 = __importDefault(require("@mui/icons-material/Flip"));
const CheckCircleOutline_1 = __importDefault(require("@mui/icons-material/CheckCircleOutline"));
const InfoOutlined_1 = __importDefault(require("@mui/icons-material/InfoOutlined"));
const root_ui_1 = require("companion-app-components/flux/root-ui");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const accounts_1 = require("companion-app-components/flux/accounts");
// DATA
const actions_1 = require("data/accounts/actions");
const types_1 = require("data/institutionLogins/types");
const constants_1 = require("data/accounts/constants");
const selectors_1 = require("data/preferences/selectors");
const types_2 = require("data/AccountDiscovery/types");
// LOCAL
const Dump_1 = __importDefault(require("components/Dump"));
const NestedQMenu_1 = __importDefault(require("components/NestedQMenu"));
const QButton_1 = require("components/QButton");
const ConfirmationDialog_1 = require("components/Dialogs/ConfirmationDialog");
const AccountEditDialog_1 = __importDefault(require("components/Dialogs/AccountEditDialog"));
const useOfxShadowAccountInfoDialog_1 = __importDefault(require("components/OfxShadowAccountInfo/useOfxShadowAccountInfoDialog"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const testAddFiDialogs = false;
const AccountListItem = ({ account, index, institutionLogin }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes, cx, theme } = useStyles({ account });
    const openOfxShadowAccountInfoDialog = (0, useOfxShadowAccountInfoDialog_1.default)();
    // ====================================== Component State ================================================ //
    const [menuAnchorEl, setMenuAnchorEl] = (0, react_1.useState)(null);
    const [showEditDialog, toggleShowEditDialog] = (0, react_use_1.useToggle)(false);
    // ====================================== Redux Selectors ================================================ //
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const ofxShadowAccountIds = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getOfxShadowAccountIds)(state));
    // ====================================== Callbacks ================================================ //
    const dispatchQCSAccountAction = (0, react_1.useCallback)((id, qcsAction) => {
        if (id && qcsAction)
            dispatch(accounts_1.accountsActions.performAccountAction({ id, qcsAction }));
    }, [dispatch]);
    const handleUpdateAccount = (0, react_1.useCallback)((type, subType, params = {}) => {
        const options = Object.assign({ id: account.id }, params);
        if (type === 'INVESTMENT') {
            const data = accounts_1.accountsTypes.mkInvestmentAccount(Object.assign({ subType }, options));
            dispatch((0, actions_1.batchInvestmentAccounts)([data]));
            return;
        }
        dispatch(accounts_1.accountsActions.updateAccount(accounts_1.accountsTypes.mkUpdateAccount(type, options)));
    }, [account, dispatch]);
    const handleDeleteAccount = (0, react_1.useCallback)(() => {
        if (account.type === constants_1.ACCOUNT_TYPES.INVESTMENT) {
            dispatch((0, actions_1.batchInvestmentAccounts)([accounts_1.accountsTypes.mkInvestmentAccount({
                    id: account.id,
                    type: constants_1.ACCOUNT_TYPES.INVESTMENT,
                    isDeleted: true,
                })]));
        }
        else {
            dispatch(accounts_1.accountsActions.deleteAccount(account));
        }
    }, [account, dispatch]);
    const handleOpenMenu = (0, react_1.useCallback)((e) => {
        setMenuAnchorEl(e.currentTarget);
    }, []);
    const handleCloseMenu = (0, react_1.useCallback)(() => {
        setMenuAnchorEl(null);
    }, []);
    const updateAccountExcludeType = (0, react_1.useCallback)((type) => {
        const value = !account.get(type);
        const params = { [type]: value };
        if (type === 'isExcludedFromReports' && account.type !== 'INVESTMENT') {
            params.isExcludedFromBudgets = value;
        }
        handleUpdateAccount(account.type, account.subType, params);
    }, [account, handleUpdateAccount]);
    const handleExcludeFromAccountBar = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        updateAccountExcludeType('isExcludedFromAccountBar');
    }, [updateAccountExcludeType, handleCloseMenu]);
    const handleExcludeFromReports = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        updateAccountExcludeType('isExcludedFromReports');
    }, [updateAccountExcludeType, handleCloseMenu]);
    const handleOfxShadowAccountInfoClick = (0, react_1.useCallback)((e) => {
        e.stopPropagation();
        openOfxShadowAccountInfoDialog();
    }, [openOfxShadowAccountInfoDialog]);
    // ====================================== Dialog Kickoffs ================================================ //
    const kickoffCloseAccount = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
            id: 'close-account',
            type: ConfirmationDialog_1.DIALOG_TYPE,
            allowNesting: true,
            props: (0, immutable_1.Map)((0, ConfirmationDialog_1.mkConfirmationDialogProps)({
                title: 'Close account',
                content: `Closing ${account.name} will set the account balance to $0 and disable downloading future transactions in Quicken. You will still be able to access all of your old transactions.`,
                confirmLabel: 'Confirm',
                denyLabel: 'Cancel',
                confirmAction: () => dispatchQCSAccountAction(account.id, 'close'),
            })),
        })));
    }, [account, handleCloseMenu, dispatchQCSAccountAction, dispatch]);
    // TODO: keeping it, as it was already there commented out.
    // const kickoffMakeManual = useCallback(() => {
    //   handleCloseMenu();
    //   dispatch(rootUiActions.createDialog(rootUiTypes.mkRootUiData({
    //     id: 'make-account-manual',
    //     type: CONFIRMATION_DIALOG_TYPE,
    //     allowNesting: true,
    //     props: ImmutableMap(mkConfirmationDialogProps({
    //       title: 'Make account manual',
    //       content: `Are you sure you want to make ${account.name} manual? This will ${accountsUtils.isActiveConnectedAccount(account) ? 'disconnect from your bank and' : ''} move the account to the manual section.`,
    //       confirmLabel: 'Make Manual',
    //       denyLabel: 'Cancel',
    //       confirmAction: () => dispatchQCSAccountAction(account.id, 'make-manual'),
    //     })),
    //   })));
    // }, [account, handleCloseMenu, dispatchQCSAccountAction, dispatch]);
    const kickoffDeleteAccount = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
            id: 'delete-account',
            type: ConfirmationDialog_1.DIALOG_TYPE,
            allowNesting: true,
            props: (0, immutable_1.Map)((0, ConfirmationDialog_1.mkConfirmationDialogProps)({
                title: 'Delete account',
                content: `Deleting ${account.name} will remove all of its data and transactions from Quicken. This will not fix connection issues.`,
                confirmLabel: 'Delete',
                denyLabel: 'Cancel',
                confirmButtonVariant: QButton_1.QButtonVariantEnum.DELETE,
                confirmAction: handleDeleteAccount,
            })),
        })));
    }, [account, dispatch, handleCloseMenu, handleDeleteAccount]);
    const kickoffEditAccount = (0, react_1.useCallback)(() => {
        handleCloseMenu();
        toggleShowEditDialog();
    }, [handleCloseMenu, toggleShowEditDialog]);
    const launchUpdateCredentialsDialog = (0, react_1.useCallback)(() => {
        dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
            id: (0, uuid_1.v4)(),
            type: types_2.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
            props: (0, immutable_1.Map)((0, types_2.mkAccountDiscoveryDialogProps)({
                mode: 'UPDATE-CREDENTIALS',
                institutionLogin,
            })),
        })));
    }, [dispatch, institutionLogin]);
    const launchMfaChallengeDialog = (0, react_1.useCallback)(() => {
        const challenges = immutable_1.List.of((0, types_1.mkMfaChallengeItem)({ question: 'Test Question' }));
        dispatch(root_ui_1.rootUiActions.createDialog(root_ui_1.rootUiTypes.mkRootUiData({
            id: (0, uuid_1.v4)(),
            type: types_2.DIALOG_TYPE_ACCOUNTS_DISCOVERY,
            props: (0, immutable_1.Map)((0, types_2.mkAccountDiscoveryDialogProps)({
                mode: 'PROVIDE-MFA',
                institutionLogin,
                mfaChallenge: (0, types_1.mkMfaChallenge)({
                    institutionLoginId: institutionLogin.id,
                    challenges,
                }),
            })),
        })));
    }, [dispatch, institutionLogin]);
    // ====================================== Memoized Values ================================================ //
    const status = (0, react_1.useMemo)(() => {
        var _a;
        let retStatus = account.isClosed ? 'CLOSED' : null;
        if (!retStatus && institutionLogin && institutionLogin.institutionId && !accounts_1.accountsUtils.isActiveConnectedAccount(account)) {
            retStatus = 'DISCONNECTED';
        }
        if (!retStatus && ((_a = account.aggregators) === null || _a === void 0 ? void 0 : _a.size)) {
            const { aggStatus } = account.aggregators.get(0);
            // TODO: A number of statuses are OK and should not result in an error
            if (aggStatus && aggStatus !== 'OK') {
                retStatus = 'ERROR';
            }
        }
        if (!retStatus)
            return retStatus;
        switch (retStatus) {
            case 'CLOSED':
                return { rootClass: classes.statusClose, value: 'Closed' };
            case 'ERROR':
                return { rootClass: classes.statusError, value: 'Error' };
            case 'DISCONNECTED':
                return { rootClass: classes.statusClose, value: 'Disconnected' };
            default:
                return { rootClass: null, value: null };
        }
    }, [account, classes.statusError, classes.statusClose, institutionLogin]);
    const isOfxShadowAccount = (0, react_1.useMemo)(() => ofxShadowAccountIds.includes(account.id), [ofxShadowAccountIds, account.id]);
    const primaryListItemText = (0, react_1.useMemo)(() => (<div className={classes.primaryItem}>
      <Typography_1.default id={`account-${index}-name`} variant={'body1'}>
        {account.name}
      </Typography_1.default>
      {isOfxShadowAccount &&
            <IconButton_1.default id={`account-${index}-ofx-shadow-info`} aria-label={'Ofx shadow account info'} className={classes.ofxShadowAccountInfoButton} onClick={handleOfxShadowAccountInfoClick} size="small">
          <InfoOutlined_1.default className={classes.ofxShadowAccountInfoIcon}/>
        </IconButton_1.default>}
      {(account.isExcludedFromReports || account.isExcludedFromAccountBar) &&
            <VisibilityOff_1.default className={classes.ignoredAccountIcon} id={`account-${index}-ignored-label`}/>}
    </div>), [classes.primaryItem, account, index, classes.ignoredAccountIcon, isOfxShadowAccount,
        classes.ofxShadowAccountInfoButton, classes.ofxShadowAccountInfoIcon, handleOfxShadowAccountInfoClick]);
    const secondaryListItemText = (0, react_1.useMemo)(() => (<Box_1.default display={'flex'}>
      <Typography_1.default id={`account-${index}-type`} variant={'caption'}>
        {accounts_1.accountsTypes.getAccountTypeNodeByQcsType(account.type, account.subType).displayName}
      </Typography_1.default>
      {status && status instanceof Object &&
            <div className={classes.statusContainer}>
          <Typography_1.default id={`account-${index}-closed-label`} variant={'caption'} classes={{ root: cx(classes.statusRoot, status.rootClass) }}>
            {status.value}
          </Typography_1.default>
        </div>}
    </Box_1.default>), [account, status, classes.statusContainer, classes.statusRoot, index, cx]);
    const menuOptions = (0, react_1.useMemo)(() => {
        const retOptions = [{
                label: 'Edit account',
                onSelect: kickoffEditAccount,
                id: 'edit-account',
                startIcon: <Edit_1.default />,
                divider: true,
            }];
        if (featureFlags.get('ignoreAccount')) {
            let label = account.isExcludedFromReports ? 'Include in reports' : 'Ignore from reports';
            label = account.isExcludedFromReports ? 'Include in spending' : 'Exclude from spending';
            retOptions.push({
                label,
                onSelect: handleExcludeFromReports,
                id: account.isExcludedFromReports ? 'include-in-reports' : 'ignore-from-reports',
                startIcon: account.isExcludedFromReports ? <Visibility_1.default /> : <VisibilityOff_1.default />,
            });
        }
        retOptions.push({
            label: account.isExcludedFromAccountBar ? 'Show in account list' : 'Hide in account list',
            onSelect: handleExcludeFromAccountBar,
            id: account.isExcludedFromAccountBar ? 'show-in-account-list' : 'hide-in-account-list',
        });
        if (!account.isClosed && featureFlags.get('closeAccount')) {
            retOptions.push({ label: 'Mark as closed', onSelect: kickoffCloseAccount, id: 'account-close', startIcon: <CancelPresentation_1.default /> });
        }
        retOptions.push({ nop: true, divider: true });
        retOptions.push({
            customRender: (<Typography_1.default variant={'body1'} style={{ color: theme.palette.amount.negative, display: 'flex', alignItems: 'center' }}>
          <Delete_1.default style={{ marginRight: theme.spacing(1) }}/>
          Delete account
        </Typography_1.default>),
            onSelect: kickoffDeleteAccount,
            id: 'account-delete',
        });
        retOptions.push({ nop: true, divider: (testAddFiDialogs && institutionLogin) });
        if (testAddFiDialogs && institutionLogin) {
            retOptions.push({ label: 'Test Update Credentials', onSelect: launchUpdateCredentialsDialog, id: 'account-test-mfa-challenge', startIcon: <Flip_1.default /> });
        }
        if (testAddFiDialogs && institutionLogin) {
            retOptions.push({ label: 'Test MFA Challenge', onSelect: launchMfaChallengeDialog, id: 'account-test-mfa-challenge', startIcon: <Flip_1.default /> });
        }
        return retOptions;
    }, [account, featureFlags, handleExcludeFromReports, theme, kickoffCloseAccount, kickoffDeleteAccount,
        handleExcludeFromAccountBar, institutionLogin, kickoffEditAccount, launchMfaChallengeDialog, launchUpdateCredentialsDialog]);
    return (<ListItem_1.default className={classes.rootContainer} disableGutters>
      <Dump_1.default obj={account}/>
      <Grid_1.default container direction="row" style={{ alignItems: 'center' }}>
        <Grid_1.default item xs={5}>
          <ListItemText_1.default primary={primaryListItemText} secondary={secondaryListItemText} secondaryTypographyProps={{ component: 'div' }} className={classes.listItemText}/>
        </Grid_1.default>
        {featureFlags.get('a2A') ?
            <>
              <Grid_1.default item xs={3} className={classes.txnsTransfersStatusContainer}>
                {status && status instanceof Object ?
                    <Typography_1.default>{status.value}</Typography_1.default>
                    :
                        <CheckCircleOutline_1.default className={classes.greenCheck}/>}
              </Grid_1.default>
              <Grid_1.default item xs={3} className={classes.txnsTransfersStatusContainer}>
              </Grid_1.default>
            </>
            :
                <Grid_1.default item xs={6}/>}
        <Grid_1.default item xs={1}>
          <IconButton_1.default id={'account-menu-button'} aria-label={'More menu'} onClick={handleOpenMenu} size="large">
            <MoreVert_1.default />
          </IconButton_1.default>
        </Grid_1.default>
        <NestedQMenu_1.default id={'account-menu'} anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={handleCloseMenu} options={menuOptions}/>
      </Grid_1.default>

      <AccountEditDialog_1.default key={showEditDialog} open={showEditDialog} onClose={toggleShowEditDialog} accountId={account.id}/>

    </ListItem_1.default>);
};
AccountListItem.propTypes = {
    account: prop_types_1.default.object,
    index: prop_types_1.default.number,
    institutionLogin: prop_types_1.default.object,
};
exports.default = AccountListItem;
